import { ClassType } from "../../../types/Class";
import { put } from "../../../utils/axios-config";
import { CLASSES } from "../../../utils/constants";

export const updateClass = async (data: ClassType) => await put<ClassType, string>(CLASSES, data);